"use client";

import { AccountModal } from "@/components/account-modal";

/**
 * Real /account route — renders the same content as the legacy
 * AccountModal but inline (no drawer/dialog overlay) so the user gets
 * native browser back / footer-tab navigation.
 *
 * MobileBottomNav routes here on tap. The desktop header / balance-chip
 * still trigger the modal variant for now (keeps the «click and stay
 * on current page» pattern that desktop users expect).
 */
export default function AccountPage() {
    return (
        <AccountModal
            embedded
            // open/onOpenChange are unused in embedded mode — the modal
            // wrapper isn't rendered. Pass dummies to satisfy the type.
            open={true}
            onOpenChange={() => {}}
        />
    );
}
